import { conforms as _conforms, isObject } from 'lodash';

const conforms = _conforms({
  context: isObject,
});

export const validate = (object) => {
  if (!conforms(object)) {
    throw new Error('Incorrect bridge object!');
  }

  return object;
};

export default conforms;



// WEBPACK FOOTER //
// ./src/Bridge/bridgeSchema.js